import { matchPath } from 'react-router-dom';
import { createSelector } from 'reselect';

export const createMatchSelector = (path: string | { path: string; exact?: boolean; strict?: boolean }) =>
  createSelector(
    (state: any) => (state.router && state.router.location ? state.router.location.pathname : ''),
    (pathname: string) => matchPath(pathname, typeof path === 'string' ? { path: path } : path),
  );

export default createMatchSelector;
